import { Link } from "react-router-dom";
import MotionSection from "../common/MotionSection";
import SectionHeading from "../common/SectionHeading";
import TestimonialCard from "../testimonials/TestimonialCard";
import useTestimonials from "../../hooks/useTestimonials";

function TestimonialsPreviewSection() {
  const { testimonials, isLoading } = useTestimonials();
  const previewTestimonials = testimonials.slice(0, 3);

  return (
    <MotionSection id="testimonials-preview" className="relative py-20 md:py-24">
      <div className="mx-auto w-full max-w-7xl px-6">
        <SectionHeading
          kicker="Student Voices"
          title="Real Stories, Real Confidence"
          description="A preview of what students say about their experience with our counselling, admissions strategy, and end-to-end support."
        />

        {isLoading ? (
          <div className="mt-12 rounded-2xl border border-midnight-navy/10 bg-white/85 px-6 py-10 text-center shadow-soft">
            <p className="text-lg font-semibold text-midnight-navy">Loading student stories...</p>
          </div>
        ) : previewTestimonials.length ? (
          <div className="mt-12 grid gap-5 lg:grid-cols-3">
            {previewTestimonials.map((testimonial) => (
              <TestimonialCard key={testimonial.id} testimonial={testimonial} compact />
            ))}
          </div>
        ) : (
          <div className="mt-12 rounded-2xl border border-midnight-navy/10 bg-white/85 px-6 py-10 text-center shadow-soft">
            <p className="text-lg font-semibold text-midnight-navy">Testimonials will appear here soon.</p>
            <p className="mt-2 text-sm text-slate-text/75">
              Add stories from the admin manager to showcase student experiences.
            </p>
          </div>
        )}

        <div className="mt-10 text-center">
          <Link
            to="/testimonials"
            className="inline-flex rounded-xl border border-midnight-navy/15 bg-white/70 px-6 py-3 text-sm font-semibold text-midnight-navy hover:border-royal-blue/35 hover:bg-royal-blue/5"
          >
            View All Testimonials
          </Link>
        </div>
      </div>
    </MotionSection>
  );
}

export default TestimonialsPreviewSection;
